import styled from 'styled-components';

export const AudienceProfileModalStyled = styled.div`
  .audienceProfileModal {
   &__list {
     .list__toolsTopContainer {
       width: 100%;
     }
   }
      
    &__globalFilter {
      max-width: none;
    }
    
    &__back {
      height: auto;
      padding: 0;
      margin-bottom: 16px;
      
      & .buttonWrapper__textWrapper {
        color: ${props => props.theme.uiColors.textBodyDefault};
      }
    }
  }
`;
